<ng-template #contentHeaderTemplate>
  <div class="row">
    <div class="col-12 d-flex justify-content-end ">
      <button class="btn btn-primary" (click)="save()">
        {{ (email?.id ? 'misc.save_btn' : 'misc.create_btn') | translate }}
      </button>
    </div>
  </div>
</ng-template>

@if (email) {
  <app-tab-switcher
    [config]="[
    {link: '/administration/emails/' + this.email!.id, translationKey: 'authenticated.administration.emails.edit.tabs.details', exact: true},
    {link: '/administration/emails/' + this.email!.id + '/german', translationKey: 'authenticated.administration.emails.edit.tabs.german', exact: true},
    {link: '/administration/emails/' + this.email!.id + '/english', translationKey: 'authenticated.administration.emails.edit.tabs.english', exact: true},
    {link: '/administration/emails/' + this.email!.id + '/russian', translationKey: 'authenticated.administration.emails.edit.tabs.russian', exact: true},
  ]"
  ></app-tab-switcher>
}

<div class="row g-3">

  <div class="col-12 col-md-9 order-md-1">
    <form [formGroup]="form" (submit)="save()">
      <div class="card mb-3">
        <div class="card-header">
          {{ 'authenticated.administration.emails.edit.header' | translate }}
        </div>
        <div class="card-body">

          <div class="row">

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.title"
                label="{{'authenticated.administration.emails.edit.form.title.label' | translate }}"
                [errorMessages]="{required: ('authenticated.administration.emails.edit.form.title.validation_messages.required' | translate)}"
              ></app-form-group>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-multi-select-enum
                [enum]="EmailTypeEnum"
                [formControl]="form.controls.type"
                translateKey="emailTypeEnum"
                [multi]="false"
                label="{{'authenticated.administration.emails.edit.form.type.label' | translate }}"
                [errorMessages]="{required: ('authenticated.administration.emails.edit.form.type.validation_messages.required' | translate)}"
              ></app-multi-select-enum>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.is_primary"
                type="checkbox"
                [centerCheckbox]="true"
                label="{{'authenticated.administration.emails.edit.form.is_primary.label' | translate }}"
              ></app-form-group>
            </div>

          </div>

        </div>
      </div>
    </form>
  </div>

  @if (email) {
    <div class="col-12 col-md-3 order-md-2">
      <app-delete-card
        [disabled]="email?.is_primary ?? false"
        *appIfHasAllPermissions="[PERMISSION.ADMINISTRATION_EMAIL_DELETE_ALL]"
        itemName="{{ 'authenticated.administration.emails.delete.item' | translate }}"
        (deleteTriggered)="delete()"
      ></app-delete-card>
    </div>
  }
</div>
